import { useFlowTokensById } from '../../../store/flow-tokens/useFlowTokens';
import { useTokenContext } from '../TokenContext';

const REGEX = /\[\[(.*?)\]\]/g;

export function isTokenValue(value) {
  // seems odd but it's actually needed
  return Boolean(String(value).match(REGEX));
}

export function trimTokenBrackets(tokenString) {
  return tokenString.substring(2, tokenString.length - 2);
}

export function getTokenFlowKey(key, { kind, token }) {
  if (kind === 'local') {
    return key;
  }

  return `${token.ownerUri}|${token.ownerId}`;
}

export function getStoreKey(key) {
  const [ownerUri, id] = key.split('|');
  return `${ownerUri}:${id}`;
}

export function useToken({ value, isDropToken }) {
  const tokens = useFlowTokensById();
  const { tokensByKey } = useTokenContext();

  let token = null;
  let tokenKey = null;
  let isToken = false;

  if (value != null) {
    isToken = isTokenValue(value);

    if (isToken) {
      tokenKey = trimTokenBrackets(value);

      token = tokenKey.includes('|')
        ? (tokens.byId?.[getStoreKey(tokenKey)] ?? null)
        : (tokensByKey[tokenKey] ?? null);
    } else if (isDropToken) {
      tokenKey = value;
      token = tokenKey.includes('|')
        ? (tokens.byId?.[getStoreKey(tokenKey)] ?? null)
        : (tokensByKey[tokenKey] ?? null);
    }
  }

  return { token, tokenKey, isToken, loading: tokens.isLoading };
}

export const defaultTokenExamples = {
  string: '-',
  number: '-',
  error: 'Error',
  boolean: 'Yes',
  image: '-',
};
